module.exports = __webpack_public_path__ + "img/logo.7abe772b.png";